import { Component, OnInit, ViewChild } from '@angular/core';
import { Table, TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { LambdaService } from 'src/app/services/lambda.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-subscriptions',
  imports: [TableModule, CommonModule,  ImageModule,CardModule, IconFieldModule, InputIconModule, TableModule, InputTextModule, CommonModule, IconFieldModule, InputIconModule, ButtonModule, TagModule, ProgressSpinnerModule, FormsModule],
  templateUrl: './subscriptions.component.html',
  styleUrl: './subscriptions.component.scss'
})

export class SubscriptionsComponent implements OnInit{

  subscriptions: any = [];
  loading = false;
  @ViewChild('dt') dt!: Table;
  searchTerm: any;

  visibleEditDialog: boolean = false;

  showEditDialog() {
    this.visibleEditDialog = true;
  }

  constructor(private router: Router, private lambdaService: LambdaService, private messageService: MessageService) {}
  ngOnInit(): void {
    this.loadSubscriptions();
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement; // Afirmación de tipo
    // console.log(input.value, "searching")
    this.dt.filterGlobal(input.value, 'contains'); // Usa el valor del input
  }

  viewDetails(subscriptionId: string) {
    this.router.navigate(['/subscriptions', subscriptionId]);
  }

  goToAddSubscription(){
    this.router.navigate(['/subscriptions/add']);
  }

  get filteredShopSubscriptions() {
    if (!this.searchTerm) {
      return this.subscriptions;
    }
    return this.subscriptions.filter((subscription: any) =>
      subscription.shopSubscriptionName.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  getBackgroundClass(subscriptionId: number): string {
    switch (subscriptionId) {
      case 1:
        return 'bg-[#146c9b]'; // Color para el plan básico
      case 2:
        return 'bg-[#c9594a]'; // Color para el plan avanzado
      case 3:
        return 'bg-[#4a448f]'; // Color para el plan corporativo
      case 4:
        return 'bg-[#a3942b]'; // Color para el plan corporativo
      default:
        return 'bg-[#636974]'; // Color para planes custom (mayor de 3)
    }
  }

  getProductTypesAllowed(productsTypeId: string): string {
    if(productsTypeId.includes(',')){
      return "Varios tipos de productos";
    }

    switch (productsTypeId) {
      case "1":
        return 'Productos Convencionales'; // Color para el plan básico
      case "2":
        return 'Productos de Sesiones'; // Color para el plan avanzado
      case "3":
        return 'Productos de Seguros'; // Color para el plan corporativo
      case "4":
        return 'Productos Paquetes'; // Color para el plan corporativo
      default:
        return 'Varios'; // Color para planes custom (mayor de 3)
    }
  }

  async loadSubscriptions(){
    this.loading = true;
    await this.lambdaService.getSubscriptions()
    .then((data:any) => {
      // console.log("shops: ",data.data)
      this.subscriptions = data.data;
    })
    .catch(error => {
      let errorMessage = 'Error al cargar las tiendas: ' + error;
      console.error(errorMessage);
    })
    .finally(()=>{
      setTimeout(() => {
        this.loading = false;
      }, 500);
    })
  }

}
